import { render } from "./PCM.vue?vue&type=template&id=3733a1fb&scoped=true"
import script from "./PCM.vue?vue&type=script&lang=js"
export * from "./PCM.vue?vue&type=script&lang=js"

import "./PCM.vue?vue&type=style&index=0&id=3733a1fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3733a1fb"]])

export default __exports__